import { render, staticRenderFns } from "./JMTZCreate.vue?vue&type=template&id=e95b1f22&scoped=true&"
import script from "./JMTZCreate.vue?vue&type=script&lang=js&"
export * from "./JMTZCreate.vue?vue&type=script&lang=js&"
import style0 from "./JMTZCreate.vue?vue&type=style&index=0&id=e95b1f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95b1f22",
  null
  
)

export default component.exports